<template lang='pug'>
  .now-shiping-model.modal.fade#country-select-modal(aria-hidden='true' role='dialog' tabindex='-1' data-backdrop='static')
    .modal-dialog(role='document')
      .modal-content
        .modal-header.header
          button.close(type='button' data-dismiss='modal' aria-label='Close')
            span("aria-hidden"="true")
        .modal-body.body
          .countries-container
            h2.title {{ $t('modal.heading') }}
            form
              .select-group
                label {{ $t('modal.changeShippingCountry') }}
                select(
                  v-model='selectedCountry'
                  aria-label='Select Country'
                  @change='languagesCountry($event.currentTarget.value)'
                )
                  option(
                    v-for='country in shippingCountries'
                    v-text='country.key'
                    :value='country.value'
                  )

              .select-group
                label {{ $t('modal.changeLanguage') }}
                select(
                  v-model='selectedLanguage'
                  aria-label='Select Language'
                )
                  option.form-option(
                    v-for='language in languages'
                    v-text='language.key'
                    :value='language.value'
                  )
              .btn-wrapp
                button.btn.save-cont-btn(v-t='"modal.save"' @click.prevent='submitCountryForm')
</template>

<i18n>
{
  "lng_en": {
    "modal": {
      "heading": "Now Shipping worldwide",
      "changeShippingCountry": "Change Shipping country",
      "changeLanguage": "Change Language",
      "save": "Save & Continue"
    }
  },
  "lng_id": {
    "modal": {
      "heading": "Sekarang Pengiriman ke seluruh dunia",
      "changeShippingCountry": "Ubah negara Pengiriman",
      "changeLanguage": "Ganti BAHASA",
      "save": "Simpan & Lanjutkan"
    }
  },
  "lng_th": {
    "modal": {
      "heading": "ตอนนี้จัดส่งทั่วโลก",
      "changeShippingCountry": "เปลี่ยนประเทศที่จัดส่ง",
      "changeLanguage": "เปลี่ยนภาษา",
      "save": "บันทึกและดำเนินการต่อ"
    }
  },
  "lng_zh": {
    "modal": {
      "heading": "现在全球发货",
      "changeShippingCountry": "更改发货国家/地区",
      "changeLanguage": "改变语言",
      "save": "保存并继续"
    }
  },
  "lng_ko": {
    "modal": {
      "heading": "지금 전세계 배송",
      "changeShippingCountry": "배송 국가 변경",
      "changeLanguage": "언어 변경",
      "save": "저장하고 계속하기"
    }
  },
  "ja-JP": {
    "modal": {
      "heading": "現在、世界中に発送中",
      "changeShippingCountry": "配送国を変更する",
      "changeLanguage": "言語を変えてください",
      "save": "保存して続行"
    }
  },
  "vi-VN": {
    "modal": {
      "heading": "Hiện đang vận chuyển trên toàn thế giới",
      "changeShippingCountry": "Thay đổi quốc gia vận chuyển",
      "changeLanguage": "Thay đổi ngôn ngữ",
      "save": "Lưu & Tiếp tục"
    }
  },
  "zh-TW": {
    "modal": {
      "heading": "现在全球发货",
      "changeShippingCountry": "更改发货国家/地区",
      "changeLanguage": "改变语言",
      "save": "保存并继续"
    }
  }
}
</i18n>

<script>
import { mapState } from 'vuex'
import { languagesByCountry } from '@/modules/config/locale.js'
import { clearApiCache } from '@/modules/service-workers/utilities'

export default {
  data () {
    return {
      selectedLanguage: I18n.language,
      selectedCountry: I18n.siteCountryLs,
      languages: languagesByCountry[I18n.siteCountryLs].languagesName
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser
    }),
    shippingCountries () {
      const countries = this.$t('shippingCountries')
      return countries.map(country => {
        return {
          key: country.name,
          value: country.abbr
        }
      })
    },
    requestParams: () => vueSupport.header.requestParams
  },
  updated () {
    this.setDefaultDropDownLanguage()
  },
  methods: {
    submitCountryForm () {
      const isAdmin = this.currentUser && this.currentUser.attributes.admin

      const countryObj = Object.assign({}, {
        language_code: this.selectedLanguage,
        iso_alpha2_code: this.selectedCountry,
        src_params: isAdmin ? this.requestParams : undefined,
        global_e_switcher: true
      })

      window.htmlAxios.post('/user/change_preferences', {
        country: countryObj
      }).then((response) => {
        clearApiCache()
        window.location.href = response.data
      }).catch(console.trace)
    },
    languagesCountry (country) {
      this.languages = []
      this.languages = languagesByCountry[country].languagesName
      this.selectedLanguage = languagesByCountry[country].defaultLanguage
    },
    setDefaultDropDownLanguage () {
      if (this.languages.find(lang => lang.value === this.selectedLanguage)) return
      this.selectedLanguage = this.languages[0].value
    }
  }
}
</script>

<style lang='scss' scoped>

.btn-wrapp {
  padding: 20px;
  text-align: center;
}

.now-shiping-model .modal-dialog{
  max-width: 744px;
}

.now-shiping-model .modal-content {
  padding: 30px;
  background: url('../../../assets/images/bg-xl.jpg')no-repeat;
  background-size: 100%;
  border: 0px;
}

.now-shiping-model .title {
  font-size: 24px;
  text-align:center;
}

.now-shiping-model .title {
  font-size: 34px;
  text-align: center;
  padding: 20px 0px;
}
form{
  margin-bottom: 0px;
}
.now-shiping-model .select-group {
  display: flex;
  align-items: center;
  justify-content: center;
}
.now-shiping-model label{
  margin-bottom: 0px;
  font-size: 13px;
  color:#000;
}
.now-shiping-model .select-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 335px;
  margin: 0px auto;
  text-align: left;
  margin-bottom: 30px;
}
.now-shiping-model .select-group:last-child{
  margin-bottom: 0px;
}

.now-shiping-model label {
  font-weight: 700;
}
.now-shiping-model .select-group select {
  max-width: 169px;
  width: 100%;
  height: 40px;
  color: #191919;
  font-size: 13px;
  border: 1px solid #AAAAAA;
  background-color: $white;
  padding: 5px;
}
.now-shiping-model .select-group select:focus{
  outline: none;
}
.save-cont-btn{
  max-width: 169px;
  height: 40px;
  color: $white;
  background-color: $black;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-weight: 700;

}

.save-cont-btn {
  max-width: 169px;
  height: 40px;
  color: $white;
  background-color: $black;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  width: 100%;
  border: 0px;
}
.save-cont-btn:focus{
   outline: none;
   border: 0px;
}

.close{
  z-index: 1;
}

.now-shiping-model .close{
  display: inline;
  outline: none;
  width: 46px;
  height: 46px;
  position: absolute;
  right: 40px;
  border-radius: 50%;
  background: rgba(255,255,255,0.8);
  opacity: 1;
}
.now-shiping-model .close span{
  font-size: 31px;
  font-weight: 400;
}

@media(max-width: 991px){

  .now-shiping-model .modal-dialog {
    max-width: 504px;
  }
  .now-shiping-model .modal-content{
    background: url('../../../assets/images/bg-md.jpg')no-repeat;
    background-size: 100%;
  }
  .now-shiping-model .title {
    font-size: 30px;
    text-align: center;
    padding: 20px 0px;
  }
  .now-shiping-model .close{
    position: absolute;
    right: 15px;
  }
}

@media(max-width: 767px){
  .now-shiping-model .select-group{
    flex-direction: column;
    margin-bottom: 24px;
  }
  .now-shiping-model .modal-dialog {
    max-width: 368px;
    margin: 0px auto;
  }
  .now-shiping-model label {
    margin-bottom: 0px;
    font-size: 13px;
    color: #000;
    margin-bottom: 15px;
    width: 169px;
  }
  .now-shiping-model .title {
    font-size: 30px;
    text-align: center;
    padding: 20px 0px;
    width: 66%;
    margin: 0px auto 0px;
    line-height: 40px;
  }
  .now-shiping-model .modal-content {
    background: url('../../../assets/images/bg-sm.jpg')no-repeat;
    background-size: cover;
  }
}
</style>
